import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-35f1927e"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "card" }
const _hoisted_2 = { class: "lg:h-60 flex justify-center items-center overflow-hidden" }
const _hoisted_3 = {
  key: 0,
  class: "p-4"
}
const _hoisted_4 = ["src", "alt"]
const _hoisted_5 = ["src", "alt"]
const _hoisted_6 = { class: "py-2 px-4" }
const _hoisted_7 = { class: "mb-2 h-16 max-h-16 title overflow-hidden" }
const _hoisted_8 = { class: "leading-[26px] flex items-center mb-2 text-sm" }
const _hoisted_9 = { class: "font-heading text-primary font-bold leading-[26px] text-base" }
const _hoisted_10 = { class: "text-sm leading-6" }
const _hoisted_11 = /*#__PURE__*/_createTextVNode(" SKU: ")
const _hoisted_12 = { class: "text-heading font-medium" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_NuxtLink = _resolveComponent("NuxtLink")!
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_NuxtLink, {
        class: "",
        to: `/product/${_ctx.product._id}`
      }, {
        default: _withCtx(() => [
          (_ctx.product.mockupGallery[0] == null)
            ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                _createElementVNode("img", {
                  class: "object-cover w-full h-auto",
                  src: _ctx.imageUrl('https://static.latteprint.com/2023-04-26/1682495798725_no-image.jpg', true, 300),
                  alt: _ctx.product.name
                }, null, 8, _hoisted_4)
              ]))
            : (_openBlock(), _createElementBlock("img", {
                key: 1,
                class: "object-cover w-full h-auto",
                src: _ctx.imageUrl(_ctx.product.mockupGallery[0], true, 300),
                alt: _ctx.product.name
              }, null, 8, _hoisted_5))
        ]),
        _: 1
      }, 8, ["to"])
    ]),
    _createElementVNode("div", _hoisted_6, [
      _createElementVNode("h3", _hoisted_7, [
        _createVNode(_component_router_link, {
          to: _ctx.redirectLink(_ctx.product),
          class: "capitalize font-bold text-sm"
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.product.name), 1)
          ]),
          _: 1
        }, 8, ["to"])
      ]),
      _createElementVNode("p", _hoisted_8, [
        _createElementVNode("span", _hoisted_9, " $" + _toDisplayString(_ctx.product.displayPrice || 0), 1)
      ]),
      _createElementVNode("p", _hoisted_10, [
        _hoisted_11,
        _createElementVNode("span", _hoisted_12, _toDisplayString(_ctx.product.productCode), 1)
      ])
    ])
  ]))
}